<template>
  <div class="subscribe-template-tab">
    <StandardSearchPageView
      ref="tableWrap"
      rowKey="id"
      :columns="columns"
      :queryParams="queryParams"
      :searchOptions="searchOptions"
      :request-promise="loadWechatTemplateList"
      :show-reset-button="true"
    >
      <template v-slot:statusText="{ record }">
        {{ getStatusText(record) }}
      </template>

      <template v-slot:action="{ record }">
        <a-popconfirm
          :title="isEnabled(record) ? '确认禁用该模板吗？' : '确认启用该模板吗？'"
          @confirm="toggleStatus(record)"
        >
          <a>{{ isEnabled(record) ? '禁用' : '启用' }}</a>
        </a-popconfirm>
        <a-divider type="vertical"/>
        <a @click="openEditDialog(record)">编辑</a>
      </template>
    </StandardSearchPageView>

    <SimpleFormEditorDialog
      v-if="showDialog"
      title="编辑模板"
      :width="640"
      :item="currentRecord"
      :edit-config-list="editConfigList"
      :rules="editRules"
      @ok="submitEdit"
      @cancel="closeEditDialog"
    />
  </div>
</template>

<script>
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import SimpleFormEditorDialog from '@/customComponents/SimpleFormEditorDialog.vue'

export default {
  name: 'SubscribeTemplateTab',
  components: {
    StandardSearchPageView,
    SimpleFormEditorDialog
  },
  data() {
    return {
      queryParams: {
        templateId: '',
        status: undefined,
        merchantId: '',
        platformId: ''
      },
      searchOptions: [
        {
          name: '模板ID',
          key: 'templateId',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '状态',
          key: 'status',
          type: 'select',
          placeholder: '请选择',
          selectOptions: [
            { label: '启用', value: 1 },
            { label: '禁用', value: 0 }
          ]
        }
      ],
      showDialog: false,
      currentRecord: null,
      editConfigList: [
        {
          name: 'ID',
          key: 'id',
          disabled: true
        },
        {
          name: '模板ID',
          key: 'templateId',
          placeholder: '请输入'
        },
        {
          name: '模板编号',
          key: 'templateNo',
          placeholder: '请输入'
        },
        {
          name: '模板类目',
          key: 'category',
          placeholder: '请输入'
        },
        {
          name: '模板标题',
          key: 'title',
          placeholder: '请输入',
          disabled: true
        }
      ],
      editRules: {
        templateId: [
          { required: true, message: '请输入模板ID', trigger: 'blur' }
        ],
        templateNo: [
          { required: true, message: '请输入模板编号', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请输入模板类目', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入模板标题', trigger: 'blur' }
        ]
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: 80
        },
        {
          title: '模板ID',
          dataIndex: 'templateId',
          width: 280
        },
        {
          title: '模板编号',
          dataIndex: 'templateNo',
          width: 120
        },
        {
          title: '模板类目',
          dataIndex: 'category',
          width: 120
        },
        {
          title: '模板标题',
          dataIndex: 'title',
          width: 180
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'statusText' },
          width: 90
        },
        {
          title: '修改时间',
          dataIndex: 'updatedTime',
          width: 180
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          className: 'sticky-action-column',
          width: 130,
          fixed: 'right'
        }
      ]
    }
  },
  created() {
    const platformConfig = this.getPlatformConfig() || {}
    this.queryParams.platformId = platformConfig.platformId
    const userInfo = this.$store.getters.userInfo || {}
    if (platformConfig.platformId > 0 && String(userInfo.merchantLoginType) === '0') {
      this.queryParams.merchantId = 0
    } else {
      this.queryParams.merchantId = userInfo.merchantId
    }
  },
  methods: {
    loadWechatTemplateList(requestParams) {
      const { limitDto, merchantId, templateId, status } = requestParams
      return this.getHttpServices().getNewServeService()
        .post('/subscribeTemplate/page', {
          limitDto,
          merchantId,
          templateId: templateId || '',
          status: status === undefined || status === null ? '' : status
        })
    },
    isEnabled(record) {
      return Number(record.status) === 1 || record.status === '启用'
    },
    getStatusText(record) {
      if (record.statusText) {
        return record.statusText
      }
      return this.isEnabled(record) ? '启用' : '禁用'
    },
    openEditDialog(record) {
      this.currentRecord = { ...record }
      this.showDialog = true
    },
    closeEditDialog() {
      this.showDialog = false
      this.currentRecord = null
    },
    submitEdit(formData) {
      const params = {
        id: formData.id,
        templateId: formData.templateId,
        templateNo: formData.templateNo,
        category: formData.category
      }
      this.getHttpServices().getNewServeService()
        .post('/subscribeTemplate/update', params)
        .then(() => {
          this.$message.success('编辑成功')
          this.closeEditDialog()
          this.$refs.tableWrap.refresh(false)
        })
        .catch(err => this.showNetWorkErrorMessage(err))
    },
    toggleStatus(record) {
      const status = this.isEnabled(record) ? 0 : 1
      this.getHttpServices().getNewServeService()
        .post('/subscribeTemplate/toggleStatus', {
          id: record.id,
          status
        })
        .then(() => {
          this.$message.success(status === 1 ? '启用成功' : '禁用成功')
          this.$refs.tableWrap.refresh(false)
        })
        .catch(err => this.showNetWorkErrorMessage(err))
    }
  }
}
</script>

<style lang="less" scoped>
.subscribe-template-tab {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
